import { createSlice } from '@reduxjs/toolkit'


const ReducerGestaoProdutos = createSlice({
    
    name: "GestaoProdutos",
    initialState: {
        filtro: {
            termo: "",
            sort: { field: "descricao", order: "ascend" },
            page: 1,
            pageSize: 10
        },
        buscandoProdutos: false, 
        produtosSelecionados:[],
     
        informacoesBusca: {
            qtdProdutos: 0
        },
        listaProdutos: []
    },
    reducers: {
        atualizaFiltro: (state, {payload:filtro})=> {
            state.filtro = filtro;
        },
        atualizaProdutosSelecionados: (state, {payload:produtosSelecionados}) => {
            const novosProdutosSelecionados = [];
            state.produtosSelecionados = novosProdutosSelecionados.concat(...produtosSelecionados);
        },
        
        atualizaBuscandoProdutos: (state, {payload:buscando}) => {
            state.buscandoProdutos = buscando;
        },
      
        atualizaListaProdutos: (state, {payload:resultadoBusca}) => {
            
            const {dados:listaProdutos} = resultadoBusca;
            const {info} = resultadoBusca;
            const {qtdProdutos} = info;
            const totalPaginas = qtdProdutos / state.informacoesBusca.tamanhoPagina;
            
            const novaInformacoesBusca = Object.assign({},state.informacoesBusca, {...info, totalPaginas});
            console.log("totalPaginas", totalPaginas)
            const novaListaProdutos = [].concat(...listaProdutos);
            state.listaProdutos = novaListaProdutos;
            state.produtosSelecionados = [];
            state.informacoesBusca = novaInformacoesBusca;
        }
        
      

      
        
                
    }
})


export const { atualizaFiltro, atualizaProdutosSelecionados, atualizaBuscandoProdutos, atualizaListaProdutos } = ReducerGestaoProdutos.actions

export default ReducerGestaoProdutos.reducer